import { Box, Typography } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

export default function SinObs() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={1.5}
      px={5}
      py={4}
      textAlign="center"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={48}
        height={48}
      >
        <AssignmentOutlinedIcon sx={{ color: "text.secondary" }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: "text.primary" }}>
        No hay observaciones
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: 280 }}>
        Aun no se han registrado observaciones para este elemento.
      </Typography>
    </Box>
  );
}